import * as Yup from 'yup'

const schema = Yup.object().shape({
  name: Yup.string().required(
    'referral::referral_links_create.form.errors.required_field',
  ),
  settings: Yup.array(
    Yup.object().shape({
      financial_profile_type_alias: Yup.string(),
      adnetwork_id: Yup.string(),
      client_percent: Yup.number(),
    }),
  ),
})

export default schema
